import { OrgDepartmentAssignment, OrgPersonAssignment, PutOrganisationRequest } from '../models/organisation-detail';

// Builds the full-replace PUT body from the working-copy arrays, in their current (possibly
// drag-reordered) order — sortOrder is always the array index, never a value carried over from
// the load, so gaps/duplicates from a partial edit can't leak into the request (see
// organisations-design-spec.md §3.3 on sortOrder).
export function buildSaveRequest(
  people: OrgPersonAssignment[],
  departments: OrgDepartmentAssignment[]
): PutOrganisationRequest {
  return {
    people: people.map((person, index) => ({
      contactId: person.contactId,
      title: person.title,
      sortOrder: index,
      showMobilePhone: person.showMobilePhone,
      showPhoto: person.showPhoto
    })),
    departments: departments.map((department, index) => ({
      contactId: department.contactId,
      sortOrder: index
    }))
  };
}

// override ?? default — the three-level visibility resolution the PRD describes (Contact
// default -> per-organisation override -> effective value). Shared by the row's "Overrides
// default" badge and the Customer Preview panel so both can never disagree.
export function resolveEffectiveVisibility(override: boolean | null, contactDefault: boolean): boolean {
  return override ?? contactDefault;
}

// Grey em dash at 0, otherwise the count itself — the List's Inactive column is bolded/coloured
// in the template based on whether this is non-empty, so this stays a pure display-string helper.
export function inactiveDisplay(count: number): string {
  return count > 0 ? String(count) : '—';
}
